
import moment from "moment";
export default {
  props: {
    offerPercentage: {
      type: Number,
      default: 0
    },
    activityVenue: {
      type: String,
      default: 'Place Name'
    },
    activityName: {
      type: String,
      default: ""
    },
    activityPrice: {
      type: Number,
      default: 0
    },
    activityDiscountPrice: {
      type: Number,
      default: 0
    },
    bcount: {
      type: Number,
      default: 0
    },
    priceDifference: {
      type: Number,
      default: 0
    },
    offerNumbers: {
      type: Number,
      default: 0
    },
    newTab: {
      type: Boolean,
      default: false
    },
    offer: {
      type: Boolean,
      default: false
    },
    pickUp: {
      type: Boolean,
      default: false
    },
    isPlace: {
      type: Boolean,
      default: false
    },
    isBlog: {
      type: Boolean,
      default: false
    },
    bestSeller: {
      type: Boolean,
      default: false
    },
    activityLink: {
      type: String,
      default: "#"
    },
    blogDate: {
      type: String,
      default: "#"
    },
    blogDesc: {
      type: String,
      default: "#"
    },
    activityRating: {
      type: Number,
      default: 0
    },
    activityImage: {
      type: String
    },
    activityVenue: {
      type: String
    },
    activityDuration: {
      type: String
    },
    blogSlug: {
      type: String
    },
  },
  methods: {
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
    },
    // To format the date using moment js
    getDate(blogDateSent) {
      return moment(blogDateSent).format('ll')
    },

    goToLink(links, id) {
      if (id)
        this.$emit('blogIdSent', id)
      this.$router.push({ path: links })
    },

    bookingCalculator(value) {

      if (value < 1000) {
        if (value > 100) {
          let val = parseInt(value / 100, 10) * 100;
          return val
        }
        else {
          return value
        }

      } else {
        let len = value.length;
        let sym = len > 6 ? 'm' : 'k';
        let firstDigit = value.toString()[0];
        return firstDigit + sym
      }
    },
    // offerPercentage(activityDiscountPrice, activityPrice) {
    //         if (activityDiscountPrice > activityPrice) {
    //             let offerPercentage = activityDiscountPrice - activityPrice;
    //             if (offerPercentage > 0) {
    //                 return ((100 * (activityDiscountPrice - activityPrice) / activityDiscountPrice) > 0 && (100 * (activityDiscountPrice - activityPrice) /
    //                 activityDiscountPrice) < 100) ? parseFloat((100 * (activityDiscountPrice - activityPrice) / activityDiscountPrice).toFixed(0)) : 0
    //             } else return 0
    //         }
    //         return 0
    //     }
  }

}

